<template>
    <div class="container">
        <h2 class="title"> {{ $t('home.last_news.title') }}</h2>
        <a href="#" class="view-all"> {{ $t('home.last_news.show_all') }}</a>
        <div class="row align-items-stretch custom-card mt-4">
            <div class="col-md-4 p-0 d-flex">
                <img :src="news[0].image_path" class="img-fluid card-img">
            </div>
            <div class="col-md-8 ">
                <div class="card-body ">
                    <h5 class="fw-bold" v-html=" this.$i18n.locale == 'ar' ? news[0].translations[0].title : news[0].translations[1].title"></h5>
                    <p v-html=" this.$i18n.locale == 'ar' ? news[0].translations[0].content : news[0].translations[1].content">
                       
                    </p>
                    <button class="btn btn-primary"> {{ $t('home.last_news.learn_more') }}</button>
                </div>
            </div>

        </div>
        <DotsPagination />
    </div>
</template>
<script>
import DotsPagination from '../Pagination/DotsPagination.vue';

export default {
    props: ['news'],
    components: {
        DotsPagination
    }
}

</script>
<style scoped>
.container {
    margin-top: 40px;

}

.title {
    font-size: 36px;
    font-weight: 500;
    display: inline;
}

.view-all {
    font-size: 20px;
    font-weight: 500;
    color: #BF9F35;
    /* Gold color */
    text-decoration: none;
    float: inline-end;
    text-decoration: underline;
    cursor: pointer;
}

.custom-card {
    background-color: #FAF7EF;
    border-radius: 15px;
    overflow: hidden;
}

.custom-card .card-body {
    padding: 20px;
    padding-top: 40px;
}


.card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

h5 {
    font-size: 28px;
    font-weight: 500;
}

p {
    font-size: 24px;
    font-weight: 400;
    margin-top: 40px;
}

.btn {
    margin-top: 40px;
}
</style>